import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
export function myCustomlogo(){
  return "https://www.vetforcesolutions.com/backend/uploads/8e6f835bdae1ff1ee6c1d6b663d984dc.png"
}